import React from 'react';
import { GoogleMapsLoader, GeoSearch, CustomMarker } from 'react-instantsearch-dom-maps';
import { Popover, OverlayTrigger, Card, Button } from 'react-bootstrap';
import pinImg from '../../../images/static/pin.png';
import mapClose from '../../../images/map/map-close.png';
import { Link, hasValidPrice } from "@StarberryUtils"
import { ShowProcessedImage } from "../../common/ggfx-client/module/components/show-image";
import imageConfig from "../../../../static/images/config.json";

const Marker = ({ data, key }) => {
    const popoverRef = React.useRef(null);
    return (
        <OverlayTrigger 
            trigger="focus"
            placement="auto" 
            overlay={
                <Popover id={`popover-${key}`} className="popover-m">
                    <Popover.Content className="p-0">
                        <Card style={{ minWidth: "100%" }} className="p-0 position-relative border-0">
                            {data.images.length > 0 && 
                                <ShowProcessedImage
                                    images={data.images[0]}
                                    transforms={imageConfig.property.images.searchResults.sizes}
                                />
                            }
                            <Card.Body>
                                <Link to={`/property-${data.searchType === "sales" ? "for-sale" : "to-rent"}/${data.slug}-${data.objectID}`}>
                                    <Card.Title className="mb-1">{data.display_address}</Card.Title>
                                    <Card.Text className="mb-1">{data.title}</Card.Text>
                                    <Card.Text>{hasValidPrice(data.price) ? `${data.price_qualifier || ""} £ ${data.price.toLocaleString()}` : (data.price_qualifier || "POA")}</Card.Text>
                                </Link>    
                            </Card.Body>
                            <div className="close-btn" onClick={() => popoverRef.current.blur()}>
                                <img src={mapClose} width={18} style={{ cursor: "pointer" }} />
                            </div>
                        </Card>
                    </Popover.Content>
                </Popover>
            }
        >
            <Button onClick={(e) => {e.target.focus()}} ref={popoverRef} style={{ pointerEvents: "all"}} className="map-btn">
                <img src={pinImg} width={18} style={{ cursor: "pointer" }} id="map-icon"/>
            </Button>
        </OverlayTrigger>
    )
}
 
function MapDesktop(props) {
    return (
        <div className="property-map-geo">
            {/* <GoogleMapsLoader apiKey={process.env.GATSBY_MAP_API_KEY}"> */}
            <GoogleMapsLoader apiKey={process.env.GATSBY_MAP_API_KEY}>
                {google => (
                    <GeoSearch
                        google={google}
                        enableRefineOnMapMove={false}
                        initialZoom={1}
                    >
                        {({ hits }) => (
                            <div>
                                {hits.map((hit, i) =>  (
                                        <CustomMarker
                                            key={i}
                                            hit={hit}
                                        >
                                            <Marker data={hit}/>
                                        </CustomMarker>
                                    )
                                )}
                            </div>
                        )}
                    </GeoSearch>
                )}
            </GoogleMapsLoader>
        </div>
    );
}

export default React.memo(MapDesktop);
